import "isomorphic-unfetch";

const BASE_URI = "https://www.wordyguru.com/api/v1";
const PROXY_URI = BASE_URI;

//translation
export const postTranslate = async (from, to, message, proxy = false) => {
  const url = `${!proxy ? BASE_URI : PROXY_URI}/translation/translate`;
  const obj = { from: from, to: to, message: message };
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json"
    },
    body: JSON.stringify(obj)
  });

  const json = await res.json();
  return json;
};



// WEBPACK FOOTER //
// ./utils/apiCalls.js